import BaseViewModel from '@src/slide/infrastructure/module/independent/view-service-define/base/base-view-model';
import { IMobileToolbarProps, IMobileToolbarState } from '@src/slide/application/service/mobile-tool-bar/core/type';
import { getIosSafeBottom } from '@utils/safe-area';

export default class MobileToolBarModel extends BaseViewModel<IMobileToolbarProps> implements IMobileToolbarState {
    public finishSave = 0;
    public initialBottom = 0;
    public isEditing = false;
    public isKeyBoardOn = false;
    public isOnline;
    public keyBoardHeight = 0;
    public panelBottom = 0;
    public panelTop = 0;
    /**
     * 初始化model
     * @param props
     * @param initObj
     */
    public initModel(props?: IMobileToolbarProps, initObj?: Partial<this>) {
        const { isOnline } = initObj || { };
        this.isOnline  = navigator.onLine && isOnline;
        if (!props?.isToolbarKeepAtTop) {
            this.initialBottom = getIosSafeBottom();
        }
    }
}
